export const ROWS_BY_FILE_OPTIONS = [
  { id: 250000, name: "250000" },
  { id: 500000, name: "500000" },
  { id: 750000, name: "750000" },
  { id: 1000000, name: "1000000" },
];

export enum RewardType {
  RANDOM = "random",
  MIN_FOR_COUNTRY = "min_for_country",
  MAX_FOR_COUNTRY = "max_for_country",
}

export const REWARD_TYPE_OPTIONS = [
  { id: RewardType.RANDOM, name: "Random" },
  { id: RewardType.MIN_FOR_COUNTRY, name: "Min for country" },
  { id: RewardType.MAX_FOR_COUNTRY, name: "Max for country" },
];

export const LIMIT_COUNTRIES_TAGS = 30;

export const DEFAULT_AMOUNT = 250000;
export const DEFAULT_DATE_TO = new Date();
export const DEFAULT_DATE_FROM = new Date(
  DEFAULT_DATE_TO.getFullYear() - 1,
  DEFAULT_DATE_TO.getMonth(),
  DEFAULT_DATE_TO.getDate(),
);

export const amountValidator = (value: number) => {
  if (value && value <= 0 && !Number.isInteger(value)) {
    return "Укажите целое положительное число";
  }
};
